import API from './apiClient';

export const fetchAllConfigs = () => API.get('/config');
export const fetchConfig = (key) => API.get(`/config/${key}`);
export const updateConfig = (key, value) => API.post(`/config/${key}`, { value });
export const fetchBootstrapData = () => API.get('/config/bootstrap');
export const updateConfigsBulk = (configs) => API.post('/config/bulk', configs);

export const fetchSections = () => API.get('/sections');
export const updateSection = (identifier, sectionData) => API.post('/sections', { identifier, ...sectionData });
export const deleteSection = (identifier) => API.delete(`/sections/${identifier}`);
